<template lang="html">
  <div>
    <carousel></carousel>
    <h2 class="login-form__title loginTitle">
      Docstream
    </h2>
    <form class="login-form" v-show="loaded"
          v-on:keyup.enter="login"
          v-if="loginOptions.LocalLoginAllowed">
      <p4a-input class="login-input"
                 :type="'text'"
                 :size="'large'"
                 :warning="{visible: falseUsername, showIcon: true, message: 'Verplicht veld'}"
                 :valid="false"
                 :fullWidth="true"
                 :leftIcon="'user'"
                 :placeholder="usernamePlaceHolder"
                 :disabled="dbVersionValid"
                 :autofocus="true"
                 v-model="input.username" />

      <p4a-input class="login-input"
                 :type="'password'"
                 :size="'large'"
                 :warning="{visible: falsePassword, showIcon: true, message: 'Verplicht veld'}"
                 :valid="false"
                 :fullWidth="true"
                 :leftIcon="'password'"
                 :placeholder="$t('login.password')"
                 :disabled="dbVersionValid"
                 v-model="input.password" />

      <p4a-button class="login-button"
                  :loading="IsLoggingIn"
                  :showIcon="IsLoggingIn"
                  :onlyIconVisible="false"
                  :icon="'wait'"
                  :product="'ds'"
                  :size="'large'"
                  :disable="false"
                  :fullWidth="true"
                  :text="$t('login.login')"
                  :disabled="dbVersionValid"
                  :borderColor="borderColor"
                  :hoverColor="hoverColor"
                  :backgroundColor="backgroundColor"
                  :hoverFontColor="hoverFontColor"
                  @click="login()">
      </p4a-button>

      <p4a-toast />

      <div v-if="!dbVersionValid">
        <div class="login-form__link">
          <router-link to="/forgotpassword" class="login-form__link--section">{{ $t('login.forgotPassword') }}</router-link>
        </div>

        <div v-if="loginOptions.hasOidcProvider">
          <div class="login-form__or">
            {{ $t('login.or') }}
          </div>

          <p4a-button class="login-button" v-for="oidcProvider in loginOptions.OidcProviders"
                  :showIcon="false"
                  :onlyIconVisible="false"
                  :size="'large'"
                  :product="'portal'"
                  :disable="false"
                  :fullWidth="true"
                  :key="oidcProvider.OidcProviderId"
                  :title="oidcProvider.Description"
                  v-on:click="loginOidc(oidcProvider.LoginUrl)"
                  :text="oidcProvider.DisplayName">
          </p4a-button>
        </div>
      </div>
      <div :class="{ hidden: errorMessage == null || errorMessage == '' }" class="db__error">
        <strong class="db__error--message">
          <span class="db__error--icon">
            <p4a-icon :icon="'state-error'" />
          </span>
          {{ errorMessage }}
        </strong>
      </div>
    </form>
  </div>
</template>

<script>
import carousel from '../carousel'
import { getPostAuthRoute } from 'router'
import * as settingsApi from 'api/settingsApi'
import * as usersAndGroupsApi from 'api/usersAndGroupsApi'

export default {
  name: 'LoginInput',
  components: {
    'carousel': carousel
  },
  data () {
    return {
      dbVersionValid: false,
      IsLoggingIn: false,
      loginError: false,
      errorMessage: null,
      leftButtonDown: true,
      loginOptions: {
        LocalLoginAllowed: true,
        OidcProviders: [],
        hasOidcProvider: false
      },
      input: {
        username: null,
        password: null
      },
      authModel: {
        Authenticated: false,
        MfaRequired: true,
        SetupMfa: false
      },
      falseUsername: false,
      falsePassword: false,
      hoverColor: undefined,
      borderColor: undefined,
      backgroundColor: undefined,
      hoverFontColor: undefined,
      emailLogin: false,
      loaded: false
    }
  },
  created () {
    let self = this
    settingsApi.getDatabaseVersionOk().then(result => {
      if (result !== 'true') {
        self.dbVersionValid = true
        self.errorMessage = result
      } else {
        settingsApi.getLoginOptions().then(loginOptions => {
          // We don't need to bother with any login buttons if the only option to login is a single OIDC, so just go there right away.
          if (!loginOptions.LocalLoginAllowed && loginOptions.OidcProviders.length === 1) {
            self.loginOidc(loginOptions.OidcProviders[0].LoginUrl)
          } else {
            self.loginOptions = loginOptions
            if (loginOptions.OidcProviders.length > 0) {
              self.loginOptions.hasOidcProvider = true
            } else {
              self.loginOptions.LocalLoginAllowed = true
            }
          }
        })
      }
    })

    // Setup empty selectionStateObject.
    let storageObject = JSON.parse(window.localStorage.getItem('selectionState'))
    storageObject = {}
    storageObject.documents = []
    storageObject.comments = []
    storageObject.versions = []
    let storageString = JSON.stringify(storageObject)
    window.localStorage.setItem('selectionState', storageString)
    // Update the cookie
    let date = new Date()
    date.setDate(date.getDate() + 1)
    document.cookie = 'ds_sls=' + storageString + '; expires=' + date + '; path=/;'

    // show toast on
    this.showNotifications = localStorage.getItem('showNotifications') === 'true'
    if (localStorage.getItem('showNotifications') === null) {
      this.showNotifications = true
      localStorage.setItem('showNotifications', true)
    }

    localStorage.setItem('ds-theme-color', null)
    localStorage.setItem('ds-theme-font-color', null)
    const mainTitleTableHexColor = 'MainTitleTableHexColor'
    const mainTitleTableFontHexColor = 'MainTitleTableFontHexColor'
    const param = `?values=${mainTitleTableHexColor}&values=${mainTitleTableFontHexColor}`
    this.loaded = false
    settingsApi.getCustomerDataSettingsList(param).then(result => {
      result.forEach(element => {
        if (element.isCustom) {
          switch (element.Name) {
            case mainTitleTableHexColor:
              this.borderColor = element.Value
              this.hoverColor = element.Value
              localStorage.setItem('ds-theme-color', element.Value)
              break
            case mainTitleTableFontHexColor:
              this.backgroundColor = element.Value
              this.hoverFontColor = element.Value
              localStorage.setItem('ds-theme-font-color', element.Value)
              break
          }
        }
      })
      self.loaded = true
    }).catch(exception => {
      self.loaded = true
    })

    settingsApi.getLoginSettings().then(result => {
      if (result) {
        this.emailLogin = result.UseEmailLogin
      }
    })
  },
  methods: {
    login (event) {
      let self = this

      self.IsLoggingIn = true

      if (event) {
        event.preventDefault()
      }

      if (self.input.username === null || self.input.password === null) {
        self.inputInvalid()
      } else {
        if (self.emailLogin && !self.emailIsValid(self.input.username)) {
          self.emailInvalid()
        } else {
          usersAndGroupsApi.login({ username: self.input.username, password: self.input.password }).then(authModel => {
            let route = getPostAuthRoute()
            if (!authModel.Authenticated && authModel.SetupMfa) {
              if (this.validReturnURL(route)) {
                self.$router.push({name: 'setupmfa', params: { mfaId: authModel.MfaId, qrImage: authModel.QrImage, mfaSecret: authModel.MfaSecret }, query: route.query})
              } else {
                self.$router.push({name: 'setupmfa', params: { mfaId: authModel.MfaId, qrImage: authModel.QrImage, mfaSecret: authModel.MfaSecret }})
              }
            } else if (!authModel.Authenticated && authModel.MfaRequired) {
              if (this.validReturnURL(route)) {
                self.$router.push({name: 'loginmfa', params: { mfaId: authModel.MfaId }, query: route.query})
              } else {
                self.$router.push({name: 'loginmfa', params: { mfaId: authModel.MfaId }})
              }
            } else if (authModel.Authenticated) {
              // Redirect to return url if any, but ignore '/' because webforms sometimes give ?ReturnUrl=%2f
              if (this.validReturnURL(route)) {
                window.location = route.query.ReturnUrl
              } else {
                // Un-comment these lines when treeview is complete
                // usersAndGroupsApi.getToken().then(token => {
                //   localStorage.setItem('token', token)
                window.location = '/index.aspx'
                // })
              }
            } else {
              self.inputInvalid()
            }
          }).catch(() => {
            self.IsLoggingIn = false
            self.falseUsername = true
            self.falsePassword = true
            self.$p4aToast.show(this.$t('login.wrongLoginTitle'), this.$t('login.loginRequestError'), 'error', '3000')
          })
        }
      }
    },
    inputInvalid () {
      let self = this
      self.IsLoggingIn = false
      self.falseUsername = true
      self.falsePassword = true
      self.$p4aToast.show(this.$t('login.wrongLoginTitle'), this.$t('login.wrongLogin'), 'error', '3000')
    },
    emailInvalid () {
      let self = this
      self.IsLoggingIn = false
      self.falseUsername = true
      self.falsePassword = true
      self.$p4aToast.show(this.$t('login.wrongEmailFormat'), this.$t('login.wrongEmail'), 'error', '3000')
    },
    loginOidc (loginUrl) {
      window.location.href = loginUrl
    },
    logout () {
      let self = this
      usersAndGroupsApi.logout().then(result => {
        if (result) {
          self.$router.push({ name: 'login' })
        }
      })
    },
    emailIsValid (email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    },
    validReturnURL (route) {
      if (route && route.query && route.query.ReturnUrl && route.query.ReturnUrl !== '/') {
        let returnUrl = route.query.ReturnUrl
        let origin = window.location.origin

        // relative path referencing the same domain
        if (returnUrl.startsWith('/')) return true

        // check if the domain of the redirect URL is the same
        try {
          let originDomain = new URL(origin).host
          let returnUrlDomain = new URL(returnUrl).host
          if (originDomain !== returnUrlDomain) return false
        } catch (e) {
          return false
        }
        return true
      }
      return false
    }
  },
  computed: {
    usernamePlaceHolder () {
      return this.emailLogin ? this.$t('login.usernameWithEmail') : this.$t('login.username')
    }
  }
}
</script>

<style lang="scss">
.loginTitle {
  padding-top: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/login/inputs/loginInput.vue